import * as React from "react";
import { toDurationStr } from "../../helpers/dateTimeUtils";
import { NoValue } from "../NoValue/NoValue";

export interface DurationDisplayProps {
  durationMs: number;
}

/**
 * The DurationDisplay component can be used to display the time
 * duration in DD:HHH:MM:SS:MS format
 */
export const DurationDisplay = ({ durationMs }: DurationDisplayProps): JSX.Element => (
  <span>
    {
      durationMs === 0 ? <NoValue /> : toDurationStr(durationMs)
    }
  </span>
);
